/* =============================================================================
   Sales-system page behaviour. Progressive enhancement only — the page reads,
   the packages are selectable and the form submits with this file absent.
   Loaded only on templates/product.sales-system.json.
   ============================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-gd]');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------------
     Money — mirrors the store's own format so nothing is hard-coded to ZAR.
     --------------------------------------------------------------------------- */
  var FORMAT = window.themeMoneyFormat || 'R {{amount}}';
  function money(cents, whole) {
    var value = (cents / 100);
    var fixed = whole ? String(Math.round(value)) : value.toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDec = parts.join('.');
    return FORMAT
      .replace(/\{\{\s*amount\s*\}\}/, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  /* ---------------------------------------------------------------------------
     Scroll reveals and the hero book stack
     --------------------------------------------------------------------------- */
  function revealAll() {
    document.querySelectorAll('.gd-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  if ('IntersectionObserver' in window) {
    var reveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        reveal.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    document.querySelectorAll('.gd-reveal').forEach(function (el) { reveal.observe(el); });

    /* Safety net. The reveal styles hide real selling copy, so if the observer
       has produced nothing at all by now — a tab that loaded in the background,
       an extension that broke it — show everything rather than serve a blank
       page. A single element having been revealed proves it works, and the
       scroll reveals are left alone. */
    setTimeout(function () {
      if (!document.querySelector('.gd-reveal.is-in')) revealAll();
    }, 2500);
  } else {
    revealAll();
  }

  /* ---------------------------------------------------------------------------
     Package selection — one choice, mirrored across every form and the
     sticky bar, so the buyer can never submit a package they did not pick.
     --------------------------------------------------------------------------- */
  var forms = Array.prototype.slice.call(document.querySelectorAll('[data-gd-form]'));

  function selectPackage(variantId) {
    forms.forEach(function (form) {
      form.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.checked = input.value === variantId;
      });
    });

    var chosen = document.querySelector('input[name="id"][value="' + variantId + '"]');
    if (!chosen) return;

    document.querySelectorAll('[data-gd-sticky-price]').forEach(function (el) {
      el.textContent = chosen.dataset.price || '';
    });
    document.querySelectorAll('[data-gd-sticky-name]').forEach(function (el) {
      el.textContent = chosen.dataset.name || '';
    });
    document.querySelectorAll('[data-gd-amount]').forEach(function (el) {
      el.textContent = chosen.dataset.price || '';
    });
    document.querySelectorAll('[data-gd-was]').forEach(function (el) {
      var was = chosen.dataset.compare || '';
      el.textContent = was;
      el.hidden = !was;
    });
    document.querySelectorAll('[data-gd-save]').forEach(function (el) {
      var save = chosen.dataset.save || '';
      el.textContent = save;
      el.hidden = !save;
    });

    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  forms.forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.name === 'id') selectPackage(e.target.value);
    });
  });

  var preselected = document.querySelector('input[name="id"]:checked');
  if (preselected) selectPackage(preselected.value);

  /* ---------------------------------------------------------------------------
     Sticky purchase bar
     --------------------------------------------------------------------------- */
  var sticky = document.querySelector('[data-gd-sticky]');
  var anchor = document.querySelector('[data-gd-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', scrolledPast);
      });
    }, { rootMargin: '0px 0px -120px 0px' }).observe(anchor);
  }

  /* The bar has no radios of its own; it submits whichever form is nearest the
     top of the document, which already carries the shared selection. */
  document.querySelectorAll('[data-gd-sticky-submit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = forms[0];
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else { var b = form.querySelector('[data-atc]'); if (b) b.click(); }
    });
  });

  /* ---------------------------------------------------------------------------
     Chapter rail — arrows plus pointer dragging on desktop
     --------------------------------------------------------------------------- */
  document.querySelectorAll('[data-gd-rail]').forEach(function (rail) {
    var wrap = rail.closest('[data-gd-rail-wrap]');
    var prev = wrap && wrap.querySelector('[data-gd-rail-prev]');
    var next = wrap && wrap.querySelector('[data-gd-rail-next]');

    function step() {
      var card = rail.querySelector('.gd-ch');
      return card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' });
    });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* Drag only with a mouse — touch already scrolls natively. */
    var down = false, startX = 0, startLeft = 0, moved = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0;
      startX = e.clientX; startLeft = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      if (moved > 4) {
        rail.classList.add('is-dragging');
        rail.setPointerCapture(e.pointerId);
      }
      rail.scrollLeft = startLeft - dx;
    });
    function release(e) {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
      if (e && e.pointerId != null && rail.hasPointerCapture(e.pointerId)) {
        rail.releasePointerCapture(e.pointerId);
      }
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);
  });

  /* ---------------------------------------------------------------------------
     Unit-economics calculator

     Every pack price comes from the store's own catalogue, injected by Liquid.
     Nothing here forecasts income: it multiplies out the numbers the visitor
     enters and labels the result as a gross figure before their own costs.
     --------------------------------------------------------------------------- */
  var calc = document.querySelector('[data-gd-calc]');
  if (calc) {
    var dataEl = document.getElementById(calc.dataset.gdCalc);
    var packs = [];
    try { packs = JSON.parse(dataEl.textContent); } catch (err) { packs = []; }

    var priceInput = calc.querySelector('[data-gd-sell]');
    var volInput   = calc.querySelector('[data-gd-vol]');

    function currentPack() {
      var checked = calc.querySelector('input[name="gd-pack"]:checked');
      var qty = checked ? parseInt(checked.value, 10) : 0;
      return packs.filter(function (p) { return p.qty === qty; })[0] || packs[0];
    }

    function set(name, text) {
      var el = calc.querySelector('[data-gd-o="' + name + '"]');
      if (el) el.textContent = text;
    }

    function update() {
      var pack = currentPack();
      if (!pack) return;

      var sell   = parseInt(priceInput.value, 10) * 100;   /* cents */
      var volume = parseInt(volInput.value, 10);
      var unit   = Math.round(pack.price / pack.qty);
      var gross  = sell - unit;

      var sellOut = calc.querySelector('[data-gd-sell-out]');
      var volOut  = calc.querySelector('[data-gd-vol-out]');
      if (sellOut) sellOut.textContent = money(sell, true);
      if (volOut)  volOut.textContent  = volume + (volume === 1 ? ' card' : ' cards');

      set('stock', money(pack.price));
      set('unit', money(unit));
      set('gross', money(gross));
      set('total', money(gross * volume));

      var marginEl = calc.querySelector('[data-gd-o="margin"]');
      if (marginEl) {
        marginEl.textContent = sell > 0 ? Math.round((gross / sell) * 100) + '%' : '—';
      }

      /* An honest calculator has to be able to show a loss. */
      calc.querySelectorAll('[data-gd-loss]').forEach(function (el) { el.hidden = gross >= 0; });
    }

    calc.addEventListener('input', update);
    calc.addEventListener('change', update);
    update();
  }
})();
